/**
 * Shared constants for contract-related API calls.
 */

// Contract status enum values and _order_
export const CONTRACT_STATUS = [
  'draft',
  'confirmed',
  'in_progress',
  'done',
  'cancelled',
  'deleted',
] as const;

// Contract action enum values for status transitions
export const CONTRACT_ACTIONS = [
  'confirm',
  'start',
  'complete',
  'cancel',
  'delete',
] as const;

// Contact role enum values for contract contacts
export const CONTACT_ROLES = ['sales', 'calloff', 'delivery'] as const;

// Contact party enum values for contract contacts
export const CONTACT_PARTIES = ['buyer', 'seller'] as const;

// History entry actors enum values
export const HISTORY_ACTORS = ['buyer', 'seller', 'system', 'user'] as const;

/**
 * Mirrors the backend's `ContractDataSource` enum, for tracking where
 * contract data originated from. The OpenAPI schema itself only declares
 * `data_source` as a free-form string (`maxLength: 20`, no enum constraint),
 * but every value the backend actually sends or accepts is one of these.
 */
export const CONTRACT_DATA_SOURCE = [
  'api_integration',
  'web_manual',
  'web_ocr',
  'manual', // deprecated
  'pdf', // deprecated
  'ids', // deprecated
  'erp', // deprecated
  'api', // deprecated
] as const;

// Whether a contract item condition lowers (discount) or raises (surcharge) the price
export const CONTRACT_CONDITION_KINDS = ['discount', 'surcharge'] as const;

// What a condition's value means: a share of the price, an amount per single unit, or one flat amount
export const CONTRACT_CONDITION_VALUE_TYPES = [
  'percentage',
  'fixed_per_unit',
  'flat',
] as const;

// Why a condition does not enter the net price on the reference date
export const CONTRACT_CONDITION_NOT_IN_FORCE_REASONS = [
  'outside_validity_window',
  'outside_quantity_range',
] as const;

// Circumstances of a contract item worth the customer's attention; they never block a save
export const CONTRACT_ITEM_WARNING_CODES = [
  'price_scale_with_quantity_discount',
] as const;

export const CLEARABLE_CONTRACT_DATE_FIELDS = [
  'availabilityDate',
  'contractDate',
  'validFrom',
  'validUntil',
] as const;
